(function () {
  const loadedScripts = new Map();

  function loadScript(key, src) {
    if (loadedScripts.has(key)) {
      return loadedScripts.get(key);
    }

    const promise = new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;

      script.onload = () => resolve(true);
      script.onerror = () => {
        console.log(`[loadScript] "${key}" load failed: ${src}`);
        loadedScripts.delete(key);
        resolve(false); // ✅ 失败也 resolve
      };

      document.head.appendChild(script);
    });

    loadedScripts.set(key, promise);
    return promise;
  }

  window.loadScript = loadScript;
})();
